import react from "react";

export const KpiCard = ({ label, value, subLabel, onClick  }) => (
  <div  onClick={onClick} className="bg-white rounded-2xl shadow-sm p-4 flex flex-col justify-between border border-blue-50">
    <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">
      {label}
    </div>
    <div className="mt-2 text-2xl font-bold text-blue-700">{value}</div>
    {subLabel && (
      <div className="mt-1 text-xs text-slate-500 truncate">{subLabel}</div>
    )}
  </div>
);